export const FETCH_SLIDER_MANAGEMENT_SERIES = 'FETCH_SLIDER_MANAGEMENT_SERIES';
export const CREATE_SLIDER_MANAGEMENT_SERIES = 'CREATE_SLIDER_MANAGEMENT_SERIES';
export const DELETE_SLIDER_MANAGEMENT_SERIES = 'DELETE_SLIDER_MANAGEMENT_SERIES';
export const PATCH_SLIDER_MANAGEMENT_SERIES = 'PATCH_SLIDER_MANAGEMENT_SERIES';
export const ADD_STORY_TO_SERIES = 'ADD_STORY_TO_SERIES';